var map = {
	"./img_title_cn.png": "rruY",
	"./img_title_de.png": "u6oN",
	"./img_title_en.png": "3Jsh",
	"./img_title_es.png": "tHZ/",
	"./img_title_fr.png": "o+m0",
	"./img_title_it.png": "gkcv",
	"./img_title_jp.png": "ngdy",
	"./img_title_pt.png": "xYts",
	"./img_title_tw.png": "6GhF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PXdJ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newYear-2023 ^\.\/img_title_.*\.png$
// module id = PXdJ
// module chunks = 1